// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"Dash_gridContainer__3lvzK","Applogo":"Dash_Applogo__2bGcW","pendingContracts":"Dash_pendingContracts__1vjkH","Picturesdiv":"Dash_Picturesdiv__hZuoM"};